<template>
  <div>
    <el-card>
      <!-- <el-select
        class="m-w"
        v-model="EnterpriseListValue"
        placeholder="请选择企业"
        @change="Get_PostSelectInfo"
      >
        <el-option
          v-for="item in EnterpriseList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select> -->
      <!-- <el-select class="m-w" v-model="PostListValue" placeholder="请选择岗位">
        <el-option
          v-for="item in PostList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select> -->
      <el-select
        class="m-w"
        v-model="StatusListValue"
        placeholder="请选择审核状态"
      >
        <el-option
          v-for="item in StatusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-w"
        v-model="EvaluateListValue"
        placeholder="请选择评价状态"
      >
        <el-option
          v-for="item in EvaluateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="StudentName"
        placeholder="请输入学生名称"
      ></el-input>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="Phone"
        placeholder="请输入手机号"
      ></el-input>
      <el-button type="primary" @click="GetEP_DeliverInfoByPage"
        >查询</el-button
      >

      <el-button @click="clearData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="tui-card" v-show="isChange.length != 0">
        <div class="flex-items">
          <i class="el-icon-warning"></i>
          <div class="title">
            已选择 <span>{{ isChange.length }}</span> 项
          </div>
        </div>
        <div class="clear">清空</div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="StudentName"
          width="150"
          label="学生姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="StudyYearName"
          width="150"
          label="学届"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="GradeName"
          width="150"
          label="年级"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ClassName"
          width="150"
          label="班级"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="MaskName"
          width="150"
          label="所属"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="PostName" label="岗位名称" align="center">
        </el-table-column>
        <el-table-column
          prop="Phone"
          width="100"
          label="联系电话"
          align="center"
        >
        </el-table-column> -->
        <!-- <el-table-column prop="Detail" label="介绍" align="center">
        </el-table-column> -->
        <!-- <el-table-column label="附件地址" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              circle
              type="primary"
              @click="onClickDownLoad(scope.row.FileUrl)"
            ></el-button>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="StatusName"
          width="100"
          label="审核状态"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="EvalStatusName"
          width="100"
          label="评价状态"
          align="center"
        >
        </el-table-column>

        <el-table-column width="100" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="onClickAudit(scope.row)"
              v-if="scope.row.Status == 1"
              >去审核</el-button
            >
            <el-button
              type="text"
              @click="onClickEvaluate(scope.row)"
              v-if="scope.row.EvalStatus == 1"
              >去评价</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.EvalStatus == 2"
              @click="onClickLook(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
    <!-- 驳回 -->
    <el-dialog title="审核" :visible.sync="dialogVisibleAudit" width="30%">
      <!-- 驳回 -->
      <el-dialog
        title="驳回理由"
        :visible.sync="dialogVisibleReject"
        width="30%"
        append-to-body
      >
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="remark"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onClickCancle">取 消</el-button>
          <el-button
            type="primary"
            @click="CheckEP_DeliverInfo(3, auditItem.Id)"
            >确定驳回</el-button
          >
        </span>
      </el-dialog>
      <div>
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item label="企业社区名称">{{
            auditItem.MaskName
          }}</el-descriptions-item>
          <el-descriptions-item label="岗位名称">{{
            auditItem.PostName
          }}</el-descriptions-item>

          <el-descriptions-item label="联系电话">
            {{ auditItem.Phone }}
          </el-descriptions-item>

          <el-descriptions-item label="状态">{{
            auditItem.StatusName
          }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{
            auditItem.Remark
          }}</el-descriptions-item>
          <el-descriptions-item label="介绍">
            <div v-html="auditItem.Detail"></div>
          </el-descriptions-item>
        </el-descriptions>
        <!-- <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入内容"
          v-model="remark"
        >
        </el-input> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReject = true">驳 回</el-button>
        <el-button type="primary" @click="CheckEP_DeliverInfo(2, auditItem.Id)"
          >通 过</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="去评价"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item
            :label="item.name"
            v-for="(item, index) in rateList"
            :key="index"
          >
            <el-rate v-model="item.rate" :max="5"></el-rate>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="Eval_Stu_Mask_Post('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog title="查看" :visible.sync="dialogVisibleLook" width="30%">
      <div>
        <div
          class="flex"
          style="padding-top: 10px;"
          v-for="(item, index) in isLookList"
          :key="index"
        >
          <div style="padding-right: 10px">{{ item.name }}</div>
          <el-rate v-model="item.rate" :max="5" disabled></el-rate>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleLook = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleLook = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Get_MaskSelectInfo,
  Get_PostSelectInfo,
  GetCheckStatusSelectInfo,
  GetEP_DeliverInfoByPage,
  GetEP_MaskDetail,
  CheckEP_DeliverInfo,
  Eval_Stu_Mask_Post,
} from "../../api/api";
export default {
  data() {
    return {
      EvaluateList: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "待评价",
        },
        {
          value: "2",
          label: "已评价",
        },
      ],
      EvaluateListValue: "0",
      tableData: [],
      isChange: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      EnterpriseList: [],
      EnterpriseListValue: "",
      PostList: [],
      PostListValue: "",
      StatusList: [],
      StatusListValue: "",
      StudentName: "",
      Phone: "",
      EP_MaskId: 0,
      userInfo: {},
      auditItem: {},
      Id: 0,
      dialogVisibleAudit: false,
      dialogVisibleReject: false,
      remark: "",
      ruleForm: {
        id: 0,
        evalDetail: "",
        evalLevelEnum: 1,
      },
      dialogVisible: false,
      rules: {
        evalDetail: [
          { required: true, message: "请填写评价内容", trigger: "blur" },
        ],
        evalLevelEnum: [
          { required: true, message: "请填写评价级别", trigger: "change" },
        ],
      },
      loading: false,
      rateList: [
        {
          name: "遵守纪律",
          rate: 0,
        },
        {
          name: "工作态度",
          rate: 0,
        },
        {
          name: "工作能力",
          rate: 0,
        },
        {
          name: "团队合作",
          rate: 0,
        },
        {
          name: "总体评价",
          rate: 0,
        },
      ],
      dialogVisibleLook: false,
      isLookList: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );

    await this.GetEP_MaskDetail();
    await this.Get_MaskSelectInfo();
    await this.GetCheckStatusSelectInfo();
    await this.GetEP_DeliverInfoByPage();
  },
  methods: {
    onClickLook(val) {
      console.log(val)
      this.isLookList = val.EvalDetail ? JSON.parse(val.EvalDetail) : [];
      this.dialogVisibleLook = true;
    },
    getJson(val) {
      if (val) {
        return JSON.parse(val);
      }
    },
    onClickDownLoad(val) {
      window.open(val, "_blank");
    },
    async Eval_Stu_Mask_Post(formName) {
      let res = await Eval_Stu_Mask_Post({
        id: this.ruleForm.id,
        evalDetail: JSON.stringify(this.rateList),
        evalLevelEnum: 0,
      });
      console.log(res, "a");
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "成功",
        });

        this.GetEP_DeliverInfoByPage();
        this.loading = false;
        this.handleClose();
      } else {
        this.loading = false;

        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    handleClose() {
      this.ruleForm = {
        evalDetail: "",
        evalLevelEnum: 1,
      };
      this.dialogVisible = false;
    },
    async onClickEvaluate(item) {
      this.ruleForm.id = item.Id;
      this.dialogVisible = true;
    },
    onClickCancle() {
      this.dialogVisibleReject = false;
      this.dialogVisibleAudit = false;
      this.remark = "";
    },
    async CheckEP_DeliverInfo(status, Id) {
      let res = await CheckEP_DeliverInfo({
        status: status,
        remark: this.remark,
        id: Id,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: status == 2 ? "审核成功" : "驳回成功",
        });
        await this.GetEP_MaskDetail();
        await this.GetEP_DeliverInfoByPage();
        this.dialogVisibleAudit = false;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async onClickAudit(item) {
      this.auditItem = item;
      this.Id = item.Id;
      this.dialogVisibleAudit = true;
    },
    async GetEP_MaskDetail() {
      let res = await GetEP_MaskDetail({
        SysUserId: this.userInfo.uID,
      });
      if (res.data.success) {
        this.EP_MaskId = res.data.response.Id;
      }
    },
    async clearData() {
      this.EnterpriseListValue = "";
      this.PostListValue = "";
      this.StudentName = "";
      this.Phone = "";
      this.StatusListValue = "";
      this.EvaluateListValue = "0";
      await this.GetEP_MaskDetail();
      await this.GetEP_DeliverInfoByPage();
    },
    async GetEP_DeliverInfoByPage() {
      let res = await GetEP_DeliverInfoByPage({
        EP_MaskId: this.EP_MaskId,
        EP_PostId: 0,
        StudentName: this.StudentName,
        Phone: this.Phone,
        Status: this.StatusListValue == "" ? 0 : this.StatusListValue,
        EvalStatus: this.EvaluateListValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCheckStatusSelectInfo() {
      let res = await GetCheckStatusSelectInfo();
      if (res.data.success) {
        this.StatusList = res.data.response;
      }
    },
    async Get_MaskSelectInfo() {
      let res = await Get_MaskSelectInfo();
      if (res.data.success) {
        this.EnterpriseList = res.data.response;
      }
    },
    async Get_PostSelectInfo() {
      let res = await Get_PostSelectInfo({
        Id: this.EnterpriseListValue == "" ? 0 : this.EnterpriseListValue,
      });
      if (res.data.success) {
        this.PostList = res.data.response;
      }
    },
    async handleCurrentChange(val) {
      this.PageIndex = val;
      await this.GetEP_MaskDetail();
      this.GetEP_DeliverInfoByPage();
    },
    async handleSizeChange(val) {
      this.PageSize = val;
      await this.GetEP_MaskDetail();
      this.GetEP_DeliverInfoByPage();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  display: flex;
  align-items: center;
}
/deep/.el-form-item /deep/.el-form-item__content {
  margin-left: 0px !important;
}
.m-w {
  margin-right: 10px;
}
.tui-card {
  width: 100%;
  height: 40px;
  background-color: rgba(230, 247, 255, 1);
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(186, 231, 255, 1);
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  i {
    color: #1890ff;
  }
  .clear {
    color: #1890ff;
  }
  .title {
    padding-left: 10px;
    color: #101010;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #1890ff;
      padding: 0 5px;
    }
  }
}
</style>